export default __webpack_public_path__ + "static/c06-1c2643f27fe054b13e538fac54701104.png";